import { formatNameShort } from '@shared/entity';
import { Typography } from '@mui/material';

const UserCell = (props: { userName: string }) => (
  <Typography fontSize="12px">{formatNameShort(props.userName)}</Typography>
);

export default UserCell;
